import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logUserOut } from "../../store/slices/auth";

const Logout = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(logUserOut());
    history.replace("/");
  });

  return (
    <div>
      <h1>Logging out...</h1>
    </div>
  );
};

export default Logout;
